import React, { useState, useEffect, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import MyProntoOrders from './MyProntoOrders.jsx';
import { Context } from './StockManagerContext.jsx';
import { canSeeProntoOrders } from '../private/permissions.js';

export default function MyProntoOrdersButton() {
    const [ openModal, setOpenModal ] = useState(_ => _);
    const { currentUser } = useContext(Context);

    const showButton = currentUser && canSeeProntoOrders(currentUser.userRole);

    return showButton ? (
        <>
            <a className={`btn my-pronto-orders`} onClick={openModal} style={{ cursor: 'pointer' }}>
                My Pronto Orders
            </a>
            <MyProntoOrdersModal getMethods={methods => {
                setOpenModal(() => methods.open);
            }} />
        </>
    ) : null;
}

function MyProntoOrdersModal({ getMethods }) {

    const [ show, setShow ] = useState(false);

    useEffect(() => {
        getMethods({
            open: () => {
              setShow(true);
            }
        });
    }, []);

    const close = () => {
      setShow(false);
    };

    return (
      <>
        <Modal show={show} onHide={close} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>My Pronto Orders</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '80vh', overflow: 'auto' }}>
            <MyProntoOrders />
          </Modal.Body>
        </Modal>
      </>
    );
};
